module.exports = __webpack_public_path__ + "static/img/pdf_file.b9b7ba4c.png";